import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { IndirizzoStudioService } from "../../../src/services/IndirizzoStudioService";

const Upload = forwardRef((props, ref) => {
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState(""); // Stato per messaggio errore
  const [spinnerVisible, setSpinnerVisible] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const inputFile = useRef(null);
  const buttonSeleziona = useRef(null);
  const [uploadDisabled, setUploadDisabled] = useState(false);  
  const service = new IndirizzoStudioService();

  const handleFileChange = (event) => {
    console.log('here handleFileChange');
    const selectedFile = event.target.files[0];
    props.onFileChanged(selectedFile);
    if (selectedFile) {
      setFileName(selectedFile.name);
      setFile(selectedFile);
      setErrorMessage(""); // Reset dell'errore quando selezioni un file
      setButtonsDisabled(false); // Riattiva i bottoni se il file è valido

      const fileExtension = selectedFile.name.split(".").pop().toLowerCase();
      if (!props.validExtensions.includes(fileExtension)) {
        setErrorMessage(
          `Formato non valido! Formati accettati: ${props.validExtensions.join(
            ", "
          )}`
        );
        setUploadDisabled(true); // Disabilita solo "Carica file"
        if(props.onFileValid)
          props.onFileValid(false);
      } else {
        setUploadDisabled(false); // Riabilita "Carica file" se il formato è valido
        if(props.onFileValid)
          props.onFileValid(true);
      }
    } else {
      if(props.onFileValid)
        props.onFileValid(false);
      reset();
    }
  };

  const funzioneValidazioneEsterna = props.funzioneValidazioneEsterna;

  const uploadFile = async () => {
    console.log('here uploadFile');
    if (!file) {
      setErrorMessage("Seleziona un file prima di caricarlo.");
      return;
    }

    const fileExtension = file.name.split(".").pop().toLowerCase();

    // if (!props.validExtensions.includes(fileExtension)) {
    //   setErrorMessage(`Formato non valido! Formati accettati: ${props.validExtensions.join(", ")}`);
    //   buttonSeleziona.current.focus();
    //   return;
    // }

    // Se il file è valido, procedi con l'upload
    setErrorMessage(""); // Reset messaggio di errore
    setSpinnerVisible(true);
    props.onUploadOk();
    setButtonsDisabled(true);
    try {
      let response;
      if(funzioneValidazioneEsterna)
        response = await funzioneValidazioneEsterna(file);
      else
        response = await service.valida(file);
      
      props.onValidationDone(response, file);
    } catch (error) {
      setErrorMessage("Errore nel caricamento del file. Riprova.");
    } finally {
      setButtonsDisabled(false);
      setSpinnerVisible(false);
    }
  };

  const reset = () => {
    console.log('here reset');
    setFile(null);
    setFileName("");
    setErrorMessage(""); // Reset del messaggio di errore
    if (inputFile.current) {
      inputFile.current.value = "";
      inputFile.current.type = "text";
      inputFile.current.type = "file";
    }
  };

  const getFile = () => {
    return file;
  }

  useImperativeHandle(ref, () => ({
    reset,
    disableButtons: () => setButtonsDisabled(true),
    enableButtons: () => setButtonsDisabled(false),
    getFile
  }));

  return (
    <div className="rtds-flex flex-col gap-2 rtds-mb-3">
      <label className="rtds-input-field__label">
        {props.label}
      </label>
      <div className="relative rtds-flex items-center ">
        <input
          type="file"
          id={props.id}
          hidden
          onChange={handleFileChange}
          ref={inputFile}          
        />
        <button
        type="button"
          ref={buttonSeleziona}
          disabled={buttonsDisabled}
          onClick={() => {
            reset();
            document.getElementById(props.id).click();
          }}
          className="rtds-btn--secondary rtds-btn rtds-btn--icon-left rtds-group/button"
        >
          <svg
            className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
            aria-hidden="true"
            focusable="false"
            role="img"
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--folder-open`}
            />
          </svg>
          Seleziona<span className="lg:sx-diplay-none">&nbsp;file</span>
        </button>
        {fileName && (
          <div
            tabIndex="0"
            className={`truncate rtds-mr-1 rtds-content-03 rtds-body-sm rtds-rounded-lg rtds-px-2 rtds-content-center sx-border-left ${
              errorMessage
                ? "rtds-border-error-dark rtds-border-t-2 rtds-border-b-2 rtds-border-r-2"
                : "rtds-border-neutral-700 rtds-border-t rtds-border-b rtds-border-r"
            }`}
            style={{ height: "45px", marginLeft: "-4px" }}
          >
            {fileName}
            &nbsp;
            {errorMessage && (
              <svg
                className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-content-placeholder rtds-content-error"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
                />
              </svg>
            )}
          </div>
        )}

        {fileName && (
          <button
            disabled={uploadDisabled}
            onClick={uploadFile}
            className="rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button"
            hidden={!props.caricaVisible}
          >
            {!spinnerVisible && (
              <svg
                className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1"
                aria-hidden="true"
                focusable="false"
                role="img"
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-up-tray`}
                />
              </svg>
            )}

            {spinnerVisible && (
              <>
                <svg
                  className="rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 rtds-animate-spin"
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                  />
                </svg>

                <span className="rtds-sr-only">Caricamento...</span>
              </>
            )}

            <span className="lg:sx-diplay-none">Carica&nbsp;file</span>
          </button>
        )}
      </div>

      {/* Messaggio di errore sotto il campo */}
      {errorMessage && (
        <span className="rtds-input-field__error">{errorMessage}</span>
      )}
    </div>
  );
});

export default Upload;
